import EventsSearch from './EventsSearch';

export default EventsSearch;
